/** Interpret the provider's entered local instant in its tenant timezone. */
export function incidentLocalDateTimeToIso(date: string, time: string, timezone: string): string {
  const desired = Date.parse(`${date}T${time}:00Z`);
  if (!Number.isFinite(desired)) throw new Error('Enter a valid local date and time.');
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: timezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
  let instant = desired;
  for (let attempt = 0; attempt < 3; attempt += 1) {
    const parts = formatter.formatToParts(new Date(instant));
    const part = (kind: Intl.DateTimeFormatPartTypes) =>
      Number(parts.find((item) => item.type === kind)?.value ?? '0');
    const represented = Date.UTC(
      part('year'),
      part('month') - 1,
      part('day'),
      part('hour') === 24 ? 0 : part('hour'),
      part('minute'),
    );
    const difference = desired - represented;
    if (difference === 0) return new Date(instant).toISOString();
    instant += difference;
  }
  throw new Error('This local time does not exist in the provider timezone. Choose another time.');
}

/** Value for a datetime-local input, formatted in the provider timezone. */
export function incidentIsoToLocalInput(iso: string, timezone: string): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: timezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(new Date(iso));
  const part = (kind: Intl.DateTimeFormatPartTypes) =>
    parts.find((item) => item.type === kind)?.value ?? '';
  return `${part('year')}-${part('month')}-${part('day')}T${part('hour')}:${part('minute')}`;
}
